<template>
  <div class="home" v-if="loaded">
    <FileExplorer :content="content" :loadingContent="loadingContent" :loadingError="loadingError"
     :notInicialized="notInicialized" :notInicializedSalesforce="notInicializedSalesforce"
     :allowCreate="allowCreate" :allowDelete="allowDelete" :allowRename="allowRename" :allowUpload="allowUpload"/>
  </div>
</template>

<script>
import { getDirectory, getJWTToken, getImplantation } from '@/common/driveserver';
import FileExplorer from '@/components/file-explorer/index.vue';
import store from '../common/store';

export default {
  name: 'Home',
  components: { FileExplorer },
  data: () => ({
    loaded: false,
    content: {},
    loadingContent: true,
    loadingError: false,
    notInicialized: false,
    notInicializedSalesforce: false,
    allowCreate: false,
    allowDelete: false,
    allowRename: false,
    allowUpload: false,
  }),
  methods: {
    handleDirectoryResponse(response) {
      this.$set(this, 'content', response.data);
      this.allowCreate = response.data.allowCreate;
      this.allowDelete = response.data.allowDelete;
      this.allowRename = response.data.allowRename;
      this.allowUpload = response.data.allowUpload;
      this.loadingContent = false;
    },
    handleError(error) {
      if (error && error.response && error.response.status === 404) {
        this.loadingContent = false;
        const { data } = error.response;
        if (data === 'company') {
          this.notInicialized = true;
        } else if (data === 'salesforce') {
          this.notInicializedSalesforce = true;
        }
      } else {
        this.loadingError = true;
      }
    },
  },
  async created() {
    this.inImplantation = this.$router
      && this.$router.currentRoute
      && this.$router.currentRoute.query
      && this.$router.currentRoute.query.implantation === 'true';

    await getJWTToken()
      .then((response) => {
        if (response && response.data) {
          store.saveToken(response.data.token);
        }
      }).finally(() => {
        this.loaded = true;
      });

    try {
      if (!this.inImplantation) {
        const response = await getDirectory('');
        this.handleDirectoryResponse(response);
      } else {
        const response = await getImplantation('');
        this.handleDirectoryResponse(response);
      }
    } catch (error) {
      this.handleError(error);
    } finally {
      this.loadingContent = false;
    }
  },
};
</script>
